export const mockProducts = [
  {
    id: '1',
    title: '¡Zatch Bell! Edición Kanzenban 07',
    price: 17.95,
    discountPrice: 17.05,
    discountPercentage: 5,
    image: 'https://images.unsplash.com/photo-1618519764620-7403abdbdfe9?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'Zatch Bell',
    stock: 15,
    description: 'Edición especial Kanzenban del clásico manga Zatch Bell.'
  },
  {
    id: '2',
    title: 'One Piece Vol. 105',
    price: 8.95,
    image: 'https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'One Piece',
    stock: 25,
    description: 'La última aventura de los Piratas del Sombrero de Paja.'
  },
  {
    id: '3',
    title: 'Demon Slayer: Kimetsu no Yaiba Vol. 23',
    price: 8.50,
    discountPrice: 7.65,
    discountPercentage: 10,
    image: 'https://images.unsplash.com/photo-1612036782763-5e0b92d6031a?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'Demon Slayer',
    stock: 30,
    description: 'El volumen final de esta épica serie.'
  },
  {
    id: '4',
    title: 'My Hero Academia Vol. 36',
    price: 8.95,
    image: 'https://images.unsplash.com/photo-1626166234609-5d334cc7090b?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'My Hero Academia',
    stock: 20,
    description: 'Los héroes se enfrentan a su mayor desafío.'
  },
  {
    id: '5',
    title: 'Jujutsu Kaisen Vol. 22',
    price: 8.95,
    discountPrice: 8.05,
    discountPercentage: 10,
    image: 'https://images.unsplash.com/photo-1618519620930-1062a6dc3253?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'Jujutsu Kaisen',
    stock: 18,
    description: 'La batalla contra las maldiciones continúa.'
  },
  {
    id: '6',
    title: 'Dragon Ball Super Vol. 20',
    price: 9.95,
    image: 'https://images.unsplash.com/photo-1601645191163-3fc0d5d64e35?w=400&h=600&fit=crop',
    isNew: false,
    category: 'manga',
    series: 'Dragon Ball',
    stock: 12,
    description: 'Las nuevas aventuras de Goku y sus amigos.'
  },
  {
    id: '7',
    title: 'Attack on Titan Vol. 34',
    price: 8.95,
    discountPrice: 7.16,
    discountPercentage: 20,
    image: 'https://images.unsplash.com/photo-1618519764277-491a00c92fb0?w=400&h=600&fit=crop',
    isNew: false,
    category: 'manga',
    series: 'Attack on Titan',
    stock: 8,
    description: 'El volumen final de esta obra maestra.'
  },
  {
    id: '8',
    title: 'Chainsaw Man Vol. 14',
    price: 8.95,
    image: 'https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'Chainsaw Man',
    stock: 22,
    description: 'El caos y la acción continúan con Denji.'
  },
  {
    id: '9',
    title: 'Spy x Family Vol. 11',
    price: 8.95,
    discountPrice: 8.05,
    discountPercentage: 10,
    image: 'https://images.unsplash.com/photo-1626166234609-5d334cc7090b?w=400&h=600&fit=crop',
    isNew: true,
    category: 'manga',
    series: 'Spy x Family',
    stock: 28,
    description: 'Las aventuras de la familia Forger continúan.'
  },
  {
    id: '10',
    title: 'Tokyo Revengers Vol. 30',
    price: 8.95,
    image: 'https://images.unsplash.com/photo-1618519764620-7403abdbdfe9?w=400&h=600&fit=crop',
    isNew: false,
    category: 'manga',
    series: 'Tokyo Revengers',
    stock: 15,
    description: 'Los viajes en el tiempo de Takemichi continúan.'
  }
];

export const heroSlides = [
  {
    id: '1',
    title: 'One Piece',
    subtitle: 'La aventura pirata definitiva',
    image: 'https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=1600&h=900&fit=crop',
    ctaText: 'Ver Colección',
    ctaLink: '#manga'
  },
  {
    id: '2',
    title: 'Kimetsu No Yaiba',
    subtitle: 'Demon Slayer',
    image: 'https://images.unsplash.com/photo-1612036782763-5e0b92d6031a?w=1600&h=900&fit=crop',
    ctaText: 'Descubre Más',
    ctaLink: '#manga'
  },
  {
    id: '3',
    title: 'Dragon Ball',
    subtitle: 'El clásico que nunca pasa de moda',
    image: 'https://images.unsplash.com/photo-1601645191163-3fc0d5d64e35?w=1600&h=900&fit=crop',
    ctaText: 'Ver Todos',
    ctaLink: '#manga'
  },
  {
    id: '4',
    title: 'Jujutsu Kaisen',
    subtitle: 'La batalla contra las maldiciones',
    image: 'https://images.unsplash.com/photo-1618519620930-1062a6dc3253?w=1600&h=900&fit=crop',
    ctaText: 'Explorar',
    ctaLink: '#manga'
  },
  {
    id: '5',
    title: 'My Hero Academia',
    subtitle: 'El camino para convertirse en héroe',
    image: 'https://images.unsplash.com/photo-1626166234609-5d334cc7090b?w=1600&h=900&fit=crop',
    ctaText: 'Ver Serie',
    ctaLink: '#manga'
  }
];

export const categories = [
  {
    id: 'manga',
    name: 'Manga',
    image: 'https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=800&h=600&fit=crop',
    link: '#manga',
    icon: 'BookOpen'
  },
  {
    id: 'comics',
    name: 'Cómics',
    image: 'https://images.unsplash.com/photo-1612036782391-e55e16f08c3a?w=800&h=600&fit=crop',
    link: '#comics',
    icon: 'Book'
  },
  {
    id: 'artbooks',
    name: 'Artbooks',
    image: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=800&h=600&fit=crop',
    link: '#artbooks',
    icon: 'Palette'
  },
  {
    id: 'games',
    name: 'Juegos',
    image: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=800&h=600&fit=crop',
    link: '#games',
    icon: 'Gamepad2'
  },
  {
    id: 'merch',
    name: 'Merchandising',
    image: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&h=600&fit=crop',
    link: '#merchandising',
    icon: 'ShoppingBag'
  }
];